/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Swap_DirectionInputs */



/**
* | output |
* | --- |
* | "Swap direction" |
*
* @param {Event_Group_Sync_Swap_DirectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_swap_direction = /** @type {((inputs?: Event_Group_Sync_Swap_DirectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Swap_DirectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Swap direction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Swap direction")
	if (locale === "it") return /** @type {LocalizedString} */ ("Swap direction")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Swap direction")
	if (locale === "es") return /** @type {LocalizedString} */ ("Swap direction")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Swap direction")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Swap direction")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Swap direction")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Swap direction")
	return /** @type {LocalizedString} */ ("Swap direction")
});